// Assets/membership-toggle-mobile.js

document.addEventListener('DOMContentLoaded', function() {
  // Retrieve toggle buttons by their IDs
  var monthlyBtn = document.getElementById('mobile-monthly-btn');
  var annuallyBtn = document.getElementById('mobile-annually-btn');

  // Retrieve membership cards containers by their IDs
  var monthlyMemberships = document.getElementById('mobile-monthly-memberships');
  var annuallyMemberships = document.getElementById('mobile-annually-memberships');

  // Variables to store Flickity instances
  var monthlyCarousel, annuallyCarousel;

  // Function to initialize Flickity carousel
  function initCarousel() {
    console.log('Initializing Monthly Carousel');
    monthlyCarousel = new Flickity(monthlyMemberships, {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      initialIndex: 0, // Start with the first cell
      wrapAround: false // Disable infinite scrolling
    });

    console.log('Initializing Annual Carousel');
    annuallyCarousel = new Flickity(annuallyMemberships, {
      cellAlign: 'center',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      initialIndex: 0, // Start with the first cell
      wrapAround: false // Disable infinite scrolling
    });

    // Trigger Flickity to layout after initialization
    monthlyCarousel.resize();
    annuallyCarousel.resize();
  }

  // Initialize carousel after all images have loaded
  if (monthlyMemberships && annuallyMemberships) {
    imagesLoaded(monthlyMemberships, function() {
      imagesLoaded(annuallyMemberships, function() {
        initCarousel();
      });
    });
  } else {
    console.warn('Carousel containers not found.');
  }

  // Function to activate Monthly memberships
  function activateMonthly() {
    console.log('Monthly button clicked');
    monthlyMemberships.style.display = 'block';
    annuallyMemberships.style.display = 'none';

    monthlyBtn.classList.add('active');
    annuallyBtn.classList.remove('active');

    // Accessibility attributes
    monthlyBtn.setAttribute('aria-pressed', 'true');
    annuallyBtn.setAttribute('aria-pressed', 'false');

    // Resize Flickity carousel to adjust to the new display
    if (monthlyCarousel) {
      monthlyCarousel.resize();
    }
  }

  // Function to activate Annual memberships
  function activateAnnual() {
    console.log('Annual button clicked');
    monthlyMemberships.style.display = 'none';
    annuallyMemberships.style.display = 'block';

    annuallyBtn.classList.add('active');
    monthlyBtn.classList.remove('active');

    // Accessibility attributes
    annuallyBtn.setAttribute('aria-pressed', 'true');
    monthlyBtn.setAttribute('aria-pressed', 'false');

    // Resize Flickity carousel to adjust to the new display
    if (annuallyCarousel) {
      annuallyCarousel.resize();
    }
  }

  // Attach event listeners to the toggle buttons if they exist
  if (monthlyBtn && annuallyBtn && monthlyMemberships && annuallyMemberships) {
    // Set initial display states
    monthlyMemberships.style.display = 'block';
    annuallyMemberships.style.display = 'none';

    // Attach click event to Monthly button
    monthlyBtn.addEventListener('click', activateMonthly);

    // Attach click event to Annual button
    annuallyBtn.addEventListener('click', activateAnnual);
  } else {
    console.warn('Toggle buttons or membership containers not found.');
  }
});
